import Loadable from 'react-loadable';
import React, { memo } from 'react';
import { Router } from '@reach/router';
import { _cs } from '@togglecorp/fujs';

import DangerButton from '#rsca/Button/DangerButton';

import Loading from '#components/view/Loading';
import Navbar from '#components/view/Navbar';
import errorBound from '#components/general/errorBound';
import helmetify from '#components/general/helmetify';

import { routeSettings } from '#constants';
import styles from './styles.scss';

interface LoadOptions {
    error: string;
    retry: () => void;
}

function reloadPage(): void {
    window.location.reload(false);
}

const ErrorInPage = () => (
    <div className={styles.pageError}>
        <div className={styles.message}>
            Some problem occured.
        </div>
        <DangerButton
            transparent
            onClick={reloadPage}
        >
            Reload
        </DangerButton>
    </div>
);

const RetryableErrorInPage = ({ error, retry }: LoadOptions) => {
    console.error(error);
    return (
        <div className={styles.retryablePageError}>
            <div className={styles.message}>
                Some problem occured.
            </div>
            <DangerButton
                onClick={retry}
                transparent
            >
                Reload
            </DangerButton>
        </div>
    );
};

const LoadingPage = ({ error, retry }: LoadOptions) => {
    if (error) {
        return (
            <RetryableErrorInPage
                error={error}
                retry={retry}
            />
        );
    }
    return (
        <Loading
            text="Loading Page"
            pending
        />
    );
};

const routes = routeSettings.map(
    ({ load, ...settings }) => {
        type ExtendedType = typeof settings & { className?: string };

        const Component = errorBound<ExtendedType>(ErrorInPage)(
            helmetify(
                Loadable({
                    loader: load,
                    loading: LoadingPage,
                }),
            ),
        );

        return (
            <Component
                key={settings.name}
                className={styles.content}
                {...settings}
            />
        );
    },
);

interface Props {
    pending: boolean;
}

const Multiplexer = (props: Props) => {
    const {
        pending,
    } = props;

    return (
        <div className={styles.mis}>
            <Navbar className={styles.navbar} />
            <div className={_cs(styles.appMainContent, 'app-main-content')}>
                { pending ? (
                    <Loading
                        className={styles.loading}
                        text="Loading Resources"
                        pending
                    />
                ) : (
                    <Router className={styles.router}>
                        {routes}
                    </Router>
                )}
            </div>
        </div>
    );
};

export default memo(Multiplexer);
